let items = [
    {
		"name": "Steak haché",
		"category": "Assiettes",
		"url": "kebabplate.jpg",
		"desc": "Steak haché grillé servi avec nos frites maison et crudités",
		"price": "10,00"
	},
	{
		"name": "Kebab",
		"category": "Assiettes",
		"url": "kebabplate.jpg",
		"desc": "Viande Kebab servi avec nos frites maison et crudités",
		"price": "10,00"
	},
	{
		"name": "Tender",
		"category": "Assiettes",
		"url": "kebabplate.jpg",
		"desc": "Tender servi avec nos frites maison et crudités",
		"price": "10,00"
	},
	{
		"name": "Burger Classique",
		"category": "Burgers",
		"url": "cheeseburger.jpg",
		"desc": "Steak, fromage, oignons, salade (sauce au choix)",
		"price": "8,00"
	},
	{
		"name": "Burger double",
		"category": "Burgers",
		"url": "cheeseburger.jpg",
		"desc": "2 Steaks, oeuf, fromage, oignons, salade, tomate (sauce au choix)",
		"price": "12,00"
	},
	{
		"name": "Burger tender",
		"category": "Burgers",
		"url": "cheeseburger.jpg",
		"desc": "Tender, salade, fromage, oignons, sauce",
		"price": "9,50"
	},
		{
		"name": "Burger raclette",
		"category": "Burgers",
		"url": "cheeseburger.jpg",
		"desc": "Steak, galette de pomme de terre, fromage a raclette, oignons, salade (sauce au choix)",
		"price": "10,00"
	},
	{
		"name": "Kebab",
		"category": "Kebab pain rond",
		"url": "kebab.jpg",
		"desc": "Kebab, tomate, salade, sauce fromagère",
		"price": "9,00"
	},
	{
		"name": "Kebab frite",
		"category": "Kebab pain rond",
		"url": "kebab.jpg",
		"desc": "Kebab, tomate, salade, frite, sauce fromagere",
		"price": "10,00"
	},
	{
		"name": "Panini jambon fromage",
		"category": "Paninis",
		"url": "panini.jpg",
		"desc": "Jambon de poulet, emmental",
		"price": "6,50"
	},
	{
		"name": "Panini trois fromages",
		"category": "Paninis",
		"url": "panini.jpg",
		"desc": "Brie, chèvre, cheedar",
		"price": "7,00"
	},
	{
		"name": "Panini chèvre miel",
		"category": "Paninis",
		"url": "panini.jpg",
		"desc": "Chèvre, miel",
		"price": "6,50"
	},
	{
		"name": "Panini steak brie",
		"category": "Paninis",
		"url": "panini.jpg",
		"desc": "Steak, brie",
		"price": "7,50"
	},
	{
		"name": "Panini tender curry",
		"category": "Paninis",
		"url": "panini.jpg",
		"desc": "Poulet, curry",
		"price": "7,50"
	},
	{
		"name": "Panini nutella",
		"category": "Paninis",
		"url": "panini.jpg",
		"desc": "Nutella",
		"price": "3,50"
	},
	{
		"name": "Américain steak",
		"category": "Américains",
		"url": "americain.jpg",
		"desc": "Steak, frites maison, salade, tomate, oignons, cheedar",
		"price": "10,50"
	},
	{
		"name": "Américain tender",
		"category": "Américains",
		"url": "americain.jpg",
		"desc": "Tender, frites maison, salade, tomate, oignons, cheedar",
		"price": "10,50"
	},
	{
		"name": "Américain kebab",
		"category": "Américains",
		"url": "americain.jpg",
		"desc": "Kebab, frites maison, salade, tomate, oignons",
		"price": "10,50"
	},
	{
		"name": "Tacos steak",
		"category": "Tacos",
		"url": "tacos.jpg",
		"desc": "Crêpe tacos, salade, frites maison, steak, sauce fromagère maison",
		"price": "10,00"
	},
	{
		"name": "Tacos tender",
		"category": "Tacos",
		"url": "tacos.jpg",
		"desc": "Crêpe tacos, salade, frites maison, tender, sauce fromagère maison",
		"price": "10,00"
	},
	{
		"name": "Tacos kebab",
		"category": "Tacos",
		"url": "tacos.jpg",
		"desc": "Crêpe tacos, salade, frites maison, kebab, sauce fromagère maison",
		"price": "10,00"
	},
	{
		"name": "Tacos 3 viandes",
		"category": "Tacos",
		"url": "tacos.jpg",
		"desc": "Crêpe tacos, salade, frites maison, 3 viandes au choix, sauce fromagère maison",
		"price": "14,50"
	},
	{
		"name": "Nuggets x 4",
		"category": "Nuggets",
		"url": "nuggets.jpg",
		"desc": "Nuggets plein filet",
		"price": "5,00"
	},
	{
		"name": "Nuggets x 8",
		"category": "Nuggets",
		"url": "nuggets.jpg",
		"desc": "Nuggets plein filet",
		"price": "9,00"
	},
	{
		"name": "Petite frites",
		"category": "Frites",
		"url": "frite.jpg",
		"desc": "Barquette d'environs 150 g de frites",
		"price": "2,50"
	},
	{
		"name": "Moyenne frites",
		"category": "Frites",
		"url": "frite.jpg",
		"desc": "Barquette d'environs 250 g de frites",
		"price": "3,50"
	},
	{
		"name": "Grande frites",
		"category": "Frites",
		"url": "frite.jpg",
		"desc": "Barquette d'environs 500 g de frites",
		"price": "4,50"
	},
	{
		"name": "Menu enfant",
		"category": "Menus",
		"url": "menu.png",
		"desc": "Au choix: 4 nuggets ou panini jambon fromage + frites + boisson",
		"price": "9,00"
	},
	{
		"name": "Menu adulte",
		"category": "Menus",
		"url": "menu.png",
		"desc": "Au choix: kebab ou panini ou burger ou tacos (hors double burger) + frites + boisson + dessert",
		"price": "14,50"
	},
	{
		"name": "Sauce blanche pita",
		"category": "Sauces",
		"url": "",
		"desc": "",
		"price": ""
	},
	{
		"name": "Sauce mayonnaise",
		"category": "Sauces",
		"url": "",
		"desc": "",
		"price": ""
	},
	{
		"name": "Sauce ketchup",
		"category": "Sauces",
		"url": "",
		"desc": "",
		"price": ""
	},
	{
		"name": "Sauce barbecue",
		"category": "Sauces",
		"url": "",
		"desc": "",
		"price": ""
	},
	{
		"name": "Sauce algérienne",
		"category": "Sauces",
		"url": "",
		"desc": "",
		"price": ""
	},
	{
		"name": "Sauce andalouse",
		"category": "Sauces",
		"url": "",
		"desc": "",
		"price": ""
	},
	{
		"name": "Sauce brazil",
		"category": "Sauces",
		"url": "",
		"desc": "",
		"price": ""
	},
	{
		"name": "Sauce burger",
		"category": "Sauces",
		"url": "",
		"desc": "",
		"price": ""
	},
	{
		"name": "Sauce samouraï",
		"category": "Sauces",
		"url": "",
		"desc": "",
		"price": ""
	},
	{
		"name": "Sauce moutarde",
		"category": "Sauces",
		"url": "",
		"desc": "",
		"price": ""
	},
	{
		"name": "Coca",
		"category": "Boissons",
		"url": "coca.jpg",
		"desc": "33cl",
		"price": "2,00"
	},
	{
		"name": "Oasis tropical",
		"category": "Boissons",
		"url": "oasis-tropical.jpg",
		"desc": "33cl",
		"price": "2,00"
	},
	{
		"name": "Coca Cherry",
		"category": "Boissons",
		"url": "coca-cherry.jpg",
		"desc": "33cl",
		"price": "2,00"
	},
	{
		"name": "Coca zéro",
		"category": "Boissons",
		"url": "coca-zero.png",
		"desc": "33cl",
		"price": "2,00"
	},
	{
		"name": "Perrier",
		"category": "Boissons",
		"url": "perrier.jpg",
		"desc": "33cl",
		"price": "2,00"
	},
	{
		"name": "Orangina",
		"category": "Boissons",
		"url": "orangina.jpg",
		"desc": "33cl",
		"price": "2,00"
	},
	{
		"name": "Fanta citron",
		"category": "Boissons",
		"url": "fanta-orange.png",
		"desc": "33cl",
		"price": "2,00"
	},
	{
		"name": "Ice tea",
		"category": "Boissons",
		"url": "ice-tea.jpg",
		"desc": "33cl",
		"price": "2,00"
	},
	{
		"name": "Eau",
		"category": "Boissons",
		"url": "eau.jpg",
		"desc": "33cl",
		"price": "1,50"
	},
	{
		"name": "Schweppes agrume",
		"category": "Boissons",
		"url": "schweppes-agrume.jpg",
		"desc": "33cl",
		"price": "2,00"
	},
  ]

  export default items;